/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as ProtectedImport } from './routes/_protected'
import { Route as IndexImport } from './routes/index'

// Create Virtual Routes

const ProtectedUserManagementIndexLazyImport = createFileRoute(
  '/_protected/user-management/',
)()
const ProtectedApprovalsIndexLazyImport = createFileRoute(
  '/_protected/approvals/',
)()

// Create/Update Routes

const ProtectedRoute = ProtectedImport.update({
  id: '/_protected',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const ProtectedUserManagementIndexLazyRoute =
  ProtectedUserManagementIndexLazyImport.update({
    path: '/user-management/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/user-management/index.lazy').then(
      (d) => d.Route,
    ),
  )

const ProtectedApprovalsIndexLazyRoute =
  ProtectedApprovalsIndexLazyImport.update({
    path: '/approvals/',
    getParentRoute: () => ProtectedRoute,
  } as any).lazy(() =>
    import('./routes/_protected/approvals/index.lazy').then((d) => d.Route),
  )

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedImport
      parentRoute: typeof rootRoute
    }
    '/_protected/approvals/': {
      id: '/_protected/approvals/'
      path: '/approvals'
      fullPath: '/approvals'
      preLoaderRoute: typeof ProtectedApprovalsIndexLazyImport
      parentRoute: typeof ProtectedImport
    }
    '/_protected/user-management/': {
      id: '/_protected/user-management/'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof ProtectedUserManagementIndexLazyImport
      parentRoute: typeof ProtectedImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren({
  IndexRoute,
  ProtectedRoute: ProtectedRoute.addChildren({
    ProtectedApprovalsIndexLazyRoute,
    ProtectedUserManagementIndexLazyRoute,
  }),
})

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_protected"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_protected": {
      "filePath": "_protected.tsx",
      "children": [
        "/_protected/approvals/",
        "/_protected/user-management/"
      ]
    },
    "/_protected/approvals/": {
      "filePath": "_protected/approvals/index.lazy.tsx",
      "parent": "/_protected"
    },
    "/_protected/user-management/": {
      "filePath": "_protected/user-management/index.lazy.tsx",
      "parent": "/_protected"
    }
  }
}
ROUTE_MANIFEST_END */
